{
  "name": "web-mp-account",
  "version": "3.2026.11",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4202",
    "build": "ng build",
    "build:dev": "ng build -c development",
    "build:prod": "ng build -c production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "packageManager": "npm@11.16.0",
  "dependencies": {
    "@angular/common": "^22.0.0",
    "@angular/compiler": "^22.0.0",
    "@angular/core": "^22.0.0",
    "@angular/forms": "^22.0.0",
    "@angular/platform-browser": "^22.0.0",
    "@angular/router": "^22.0.0",
    "@jsverse/transloco": "^8.0.0",
    "@opentelemetry/api": "^1.9.1",
    "@opentelemetry/auto-instrumentations-web": "^0.58.0",
    "@opentelemetry/exporter-trace-otlp-http": "^0.213.0",
    "@opentelemetry/resources": "^2.10.0",
    "@opentelemetry/sdk-trace-web": "^2.10.0",
    "@opentelemetry/semantic-conventions": "^1.43.0",
    "@supabase/supabase-js": "^2.110.8",
    "firebase": "^12.17.0",
    "ng-zorro-antd": "^22.0.0",
    "ngx-image-cropper": "^9.1.6",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.0.8",
    "@angular/cli": "^22.0.8",
    "@angular/compiler-cli": "^22.0.0",
    "jsdom": "^28.0.0",
    "less": "^4.2.0",
    "prettier": "^3.8.1",
    "typescript": "~6.0.2",
    "vitest": "^4.0.8",
    "wrangler": "^4.116.0"
  }
}
